var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterOrderLightBlueNoBgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.71436C1 2.60979 1.89543 1.71436 3 1.71436H9.125H12C13.1046 1.71436 14 2.60979 14 3.71436V5.61046V14.0001C14 15.1046 13.1046 16.0001 12 16.0001H3C1.89543 16.0001 1 15.1046 1 14.0001V3.71436Z",
    stroke: "#5062F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 1,
    width: 6.5,
    height: 1.42857,
    rx: 0.714286,
    fill: "#5062F0",
    stroke: "#5062F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 9.57129L10.75 9.57129",
    stroke: "#5062F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 6.71436L10.75 6.71436",
    stroke: "#5062F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 12.4287L10.75 12.4287",
    stroke: "#5062F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterOrderLightBlueNoBgOutline);
export default __webpack_public_path__ + "static/media/registerOrderLightBlueNoBgOutline.5fe47e3795bafc3185350bb589c187c5.svg";
export { ForwardRef as ReactComponent };